import { useState } from "react"
import MonitoringApplicationConfig from "../settingTabs/monitoringApplicationConfig"
import UserRoleAssignment from "../settingTabs/userRoleAssignment"
import History from "../settingTabs/history"
import Practices from "../settingTabs/practices"
import { AUTH_EMAIL_APP_USER_REGISTRATION } from "../../utils/constants"
import Phonebook from "../settingTabs/phonebook"
import { ShieldCheck, Building2, History as HistoryIcon, BookUser } from "lucide-react"

const tabs = [
  {
    key: "userRoleAssignment",
    label: "User Role Management",
    icon: <ShieldCheck size={15} />,
  },
  {
    key: "practices",
    label: "Practice Management",
    icon: <Building2 size={15} />,
  },
  {
    key: "history",
    label: "Setting History",
    icon: <HistoryIcon size={15} />,
  },
  {
    key: "phonebook",
    label: "Phonebook",
    icon: <BookUser size={15} />,
  },
]

const Setting = ({ authUser, practices }) => {
  let defaultTab = "userRoleAssignment"
  if (authUser?.userRole === "ADMIN") {
    defaultTab = "practices"
  } else if (authUser?.userRole === "USER") {
    defaultTab = "phonebook"
  }

  const [tab, setTab] = useState(defaultTab)
  const [loading, setLoading] = useState(false)

  let permittedTabs = tabs

  if (authUser.emailAddress !== AUTH_EMAIL_APP_USER_REGISTRATION) {
    permittedTabs = permittedTabs.filter((t) => t.key !== "appUserRegister")
  }

  // if (authUser.userRole !== "SUPER_ADMIN") {
  //   permittedTabs = permittedTabs.filter((t) => t.key === "history")
  // }

  if (authUser.userRole === "ADMIN") {
    permittedTabs = permittedTabs.filter(
      (t) => t.key === "practices" || t.key === "phonebook"
    )
  } else if (authUser.userRole === "USER") {
    permittedTabs = permittedTabs.filter((t) => t.key === "phonebook")
  }

  const fetchApps = async () => {
    setLoading(true)
    try {
      await new Promise((resolve) => setTimeout(resolve, 200))
      setLoading(false)
    } catch (error) {
      console.error("Failed to fetch", error)
      setLoading(false)
    }
  }

  // useEffect(() => {
  //   fetchApps()
  // }, [])

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        borderTop: "1px solid #ccc",
      }}
    >
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div
          style={{
            width: "100%",
          }}
        >
          <div className="settings-tab-container">
            <div
              className="list-header-container"
              style={{
                width: "100%",
              }}
            >
              <div className="settings-tabs-container">
                <div className="settings-tabs-container-left">
                  {permittedTabs.map((t, i) => (
                    <div
                      key={i}
                      onClick={() => setTab(t.key)}
                      className={`settings-tab-left-tabs ${
                        tab === t.key ? "selected" : ""
                      }`}
                    >
                      <div style={{ margin: "10px", display: "flex", alignItems: "center", gap: "8px" }} key={t.key}>
                        {t.icon}
                        {t.label}
                      </div>
                      <div>
                        {tab === t.key && (
                          <button
                            title="Click to reload files"
                            className="refresh-button"
                            onClick={() => {
                              fetchApps()
                            }}
                          >
                            ↻
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="settings-tabs-container-right">
                  {loading ? (
                    <div className="loading-container-fax-list"></div>
                  ) : (
                    <>
                      {{
                        userRoleAssignment: <UserRoleAssignment />,
                        monitoringApplicationConfig: (
                          <MonitoringApplicationConfig />
                        ),
                        practices: <Practices authUser={authUser} />,
                        history: <History authUser={authUser} />,
                        phonebook: <Phonebook practices={practices} />,
                      }[tab] || null}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Setting
